import { render, staticRenderFns } from "./Pharmacies.vue?vue&type=template&id=77ee3b9c&lang=pug"
import script from "./Pharmacies.vue?vue&type=script&lang=js"
export * from "./Pharmacies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PharmaciesList: require('/home/docker/code/frontend/components/PharmaciesList.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
